import { IPagination, IProduct } from '@shared/types.ts';
import useSWR from 'swr';
import {
  fetchAllFavoriteProducts,
  addFavoriteProduct,
  addAllFavoriteProducts,
  removeFavoriteProduct,
} from './data-source.ts';
import useSWRMutation from 'swr/mutation';
import { useUser } from '../authorization/use-user.ts';
import { useSearchParams } from 'react-router-dom';

export function useFavoriteProductsService({
  onUpdate,
}: {
  onUpdate?: (products: IPagination<IProduct>) => void;
}) {
  const [searchParams, setSearchParams] = useSearchParams({
    current_page: '1',
  });
  const { isAuthenticated } = useUser();
  const { isLoading, data } = useSWR(
    isAuthenticated ? `/api/favourites?${searchParams.toString()}` : undefined,
    fetchAllFavoriteProducts,
    {
      onSuccess: (response) => {
        if (response && onUpdate) {
          onUpdate({
            data: response.data.map(({ product }) => product),
            meta: response.meta,
          });
        }
      },
    }
  );

  const updateProduct = useSWRMutation(`/api/favourites`, addFavoriteProduct);
  const updateProducts = useSWRMutation(
    `/api/favourites/batch`,
    addAllFavoriteProducts
  );
  const removeProduct = useSWRMutation(
    `/api/favourites`,
    removeFavoriteProduct
  );

  function onLoadMore(page: number) {
    searchParams.set('current_page', `${page}`);
    setSearchParams(searchParams);
  }

  return {
    isLoading,
    data,

    updateProduct,
    updateProducts,
    removeProduct,

    onLoadMore,
  };
}
